import { useListApprovalChainsQuery } from '@/store/api/complianceApi';

/** Progressive disclosure: show approval-chain UI only when tenant has chains configured. */
export function useApprovalChainsEnabled(): boolean {
  const { data } = useListApprovalChainsQuery();
  return (data?.length ?? 0) > 0;
}
